module.exports = __webpack_public_path__ + "cbcd33f86e7755152c72f3f6299ea947.svg";